export enum PageState {
  LOADING,
  LOADED,
  NO_LISTING,
}
